import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const defaultTimezone = 'Europe/Berlin';

type CalculateTime = {
  display: string;
  h: number;
  m: number;
  s: number;
  diffMs: number;
};

export function getUserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || defaultTimezone;
}

export function calculateTime(time: number, currDate: number = Date.now()): CalculateTime {
  const utcDate = new Date(time);
  const timezone = getUserTimezone();
  const localDate = toZonedTime(utcDate, timezone);
  const display = format(localDate, 'yyyy-MM-dd HH:mm:ss');
  const isMidnightCrossing = localDate.getHours() === 0 && utcDate.getUTCHours() === 23;
  const now = new Date(currDate);
  const diffMs = now.getTime() - localDate.getTime();

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const adjustedHours = isMidnightCrossing ? hours + 24 : hours;

  return { display, h: adjustedHours, m: minutes, s: seconds, diffMs };
}
